import * as React from 'react';
import { Heading, Text } from '@grandvisionhq/elements';

const Details = ({ brand , name , brandId , nameId  })=>/*#__PURE__*/ React.createElement("header", {
        className: "product-block-details"
    }, /*#__PURE__*/ React.createElement(Heading, {
        className: "product-block-details__brand",
        id: brandId,
        variant: "subheading1"
    }, brand), /*#__PURE__*/ React.createElement(Text, {
        className: "product-block-details__name",
        id: nameId,
        variant: "caption"
    }, name))
;

export { Details, Details as default };
//# sourceMappingURL=Details.js.map
